import { stats } from '@/mocks/articles';

export default function StatsSection() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            核心数据
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            一组数字，见证郝海东的传奇职业生涯
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="bg-background-100 rounded-xl p-5 md:p-7 text-center border border-background-200/70 hover:border-primary-200/60 transition-all duration-300 group"
            >
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${stat.icon} text-xl`}></i>
              </div>
              <div className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-1 flex items-baseline justify-center gap-0.5">
                <span>{stat.value}</span>
                <span className="text-base md:text-lg text-foreground-500 font-normal">{stat.suffix}</span>
              </div>
              <p className="text-foreground-600 text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}